<template>
    <div>
        <!-- 订单-返程费-编辑 -->
        <el-drawer title="编辑返程费" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="80%" destroy-on-close>
            <!-- 基本信息表单 -->
            <div class="form-box modeStyle-contain">
                <template>
                    <el-form ref="form" :model="submit_data" label-width="130px" style="height: 90vh; overflow-y: auto">
                        <el-form-item label="开启状态">
                            <el-switch v-model="submit_data.status" active-value="1" inactive-value="0"> </el-switch>
                        </el-form-item>

                        <el-form-item label="返程费名称:">
                            <el-input
                                v-model="submit_data.name"
                                :placeholder="submit_rules.name.placeholder"
                                style="width: 150px; margin-right: 5px"
                            >
                            </el-input>
                        </el-form-item>
                        <el-form-item label="生效开始时间:">
                            <el-time-picker
                                v-model="submit_data.time_start"
                                format="HH:mm"
                                value-format="HH:mm"
                                :picker-options="{
                                    selectableRange: '00:00:00 - 23:59:59'
                                }"
                                placeholder="开始时间"
                            >
                            </el-time-picker>
                        </el-form-item>
                        <el-form-item label="生效结束时间:">
                            <el-time-picker
                                v-model="submit_data.time_end"
                                format="HH:mm"
                                value-format="HH:mm"
                                :picker-options="{
                                    selectableRange: '00:00:00 - 23:59:59'
                                }"
                                placeholder="结束时间"
                            >
                            </el-time-picker>
                        </el-form-item>

                        <el-form-item label="公里数:">
                            <el-input v-model="distance_period1" placeholder="起始公里数" style="width: 150px; margin-right: 5px">
                            </el-input
                            >至
                            <el-input v-model="distance_period2" placeholder="不填则为无穷大" style="width: 150px; margin-right: 5px">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="收取返程费:">
                            <el-input v-model="submit_data.fee_amount" placeholder="元" style="width: 150px; margin-right: 5px"> </el-input
                            >+
                            <el-input v-model="submit_data.fee_rate" placeholder="订单金额百分比" style="width: 150px; margin-right: 5px">
                            </el-input
                            >%
                        </el-form-item>

                        <el-form-item label="返程费抽成:" style="margin-bottom: 0">
                            <el-input
                                v-model="submit_data.deduct"
                                :placeholder="submit_rules.deduct.placeholder"
                                style="width: 150px; margin-right: 5px"
                            >
                            </el-input>
                            元
                        </el-form-item>
                        <el-form-item label="指定订单模式:" class="modeStyle">
                            <el-button class="edit-btn" @click="editModeBtn_edit" type="primary">编辑</el-button>
                            <div v-loading="mLoading">
                                <div v-if="checkedModes_edit.length == allModeArr.length">
                                    <el-tag type="info">全部</el-tag>
                                </div>
                                <div v-else>
                                    <el-checkbox-group v-model="checkedModes_edit" disabled>
                                        <el-checkbox
                                            v-for="(item, index) in checkboxChange"
                                            :label="item.order_mode.order_mode_code"
                                            :key="index"
                                        >
                                            {{ item.name }}
                                        </el-checkbox>
                                    </el-checkbox-group>
                                </div>
                            </div>
                        </el-form-item>
                    </el-form>

                    <!-- 对话框底部按钮 -->
                    <div style="display: flex; justify-content: center">
                        <el-button type="primary" @click="toJSON">保存</el-button>
                        <el-button @click="closeDialog">关闭</el-button>
                    </div>
                </template>
            </div>
            <!-- 编辑指定订单模式组件 -->
            <editMode :isShow="editMode_show" :data="checkedModes" checkboxSelect="edit"></editMode>
        </el-drawer>
    </div>
</template>

<script>
var _this;
import editMode from './editMode.vue';
export default {
    components: {
        editMode
    },
    props: {
        isShow: Boolean,
        data: '' //return_trip_conf_code
    },
    watch: {
        async isShow(newData, oldData) {
            _this.show = true;
            _this.mLoading = true;

            _this.submit_data.return_trip_conf_code = _this.data;
            // _this.orderModeList();
            // _this.getReturnfeeDetails();

            // Promise.all([_this.orderModeList(), _this.getReturnfeeDetails()]).then(
            //   (res) => {
            //     // 详情接口赋值完成 订单模式接口走完才能判断订单模式是否选择了全部，才可以取消loading
            //     console.log("取消loading");
            //     _this.mLoading = false;
            //   }
            // );
            _this.orderModeList().then(() => {
            //   console.log('9999999');
              _this.getReturnfeeDetails().then(()=>{
                _this.mLoading = false;
              })
            });
            // await _this.orderModeList();

            // await _this.getReturnfeeDetails();

            // _this.mLoading = false;

            // console.log(a,'arr');
            // let p = Promise.all([_this.orderModeList(), _this.getReturnfeeDetails()]);
            // p.then((arr) => {
            //   _this.mLoading = false;
            // });
        }
    },

    data() {
        return {
            mLoading: false,
            return_trip_conf_code: '',
            checkboxSelect: 'edit', //添加和编辑页面公用一个子组件，传递该值用于区分是添加页面还是编辑页面
            editMode_show: false,
            distance_period1: '', //起始公里数
            distance_period2: '', //截止公里数
            allModeArr: [], // 获取订单模式后的全部订单模式的数组
            checkedModes: [],
            checkedModes_edit: [], //订单模式v-model  绑定值
            options_mode_code: [], //订单模式编码
            show: false,

            mode_options_data: {
                page: 1,
                limit: 10,
                status: ''
            },

            submit_url: '/returnfee/editReturnfeeSubmit',
            // 表单数据
            submit_data: {
                return_trip_conf_code: '',
                name: '',
                time_start: '',
                time_end: '',
                distance_period: '',
                fee_amount: '',
                fee_rate: '',
                deduct: '',
                order_mode: '',
                status: ''
            },

            submit_rules: {
                name: {
                    placeholder: '返程费名称',
                    rules: {
                        required: true,
                        message: '返程费名称10个字以内',
                        regulation: 'between_str',
                        rulesData: [1, 10]
                    }
                },
                time_start: {
                    placeholder: '开始时间',
                    rules: {
                        required: true,
                        message: '开始时间不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                time_end: {
                    placeholder: '结束时间',
                    rules: {
                        required: true,
                        message: '结束时间不正确',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },

                fee_amount: {
                    placeholder: '收取返程费固定金额',
                    rules: {
                        required: true,
                        message: '收取返程费固定金额',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },

                fee_rate: {
                    placeholder: '收取返程费百分比',
                    rules: {
                        required: true,
                        message: '收取返程费百分比',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                deduct: {
                    placeholder: '返程费抽成',
                    rules: {
                        required: true,
                        message: '返程费抽成',
                        regulation: 'egt',
                        rulesData: 0
                    }
                },
                order_mode: {
                    placeholder: '指定模式',
                    rules: {
                        required: false,
                        message: '指定模式',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                status: {
                    placeholder: '状态',
                    rules: {
                        required: true,
                        message: '状态',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    computed: {
        checkboxChange() {
            // console.log('触发');

            let returnArray = [];

            // console.log(this.checkedModes_edit, 'checkedModes_edit------------');
            // 已选择
            _this.checkedModes_edit.forEach((e) => {
                // 全部
                _this.allModeArr.forEach((j) => {
                    // 在allModeArr中查找checkedModes_edit中的code
                    if (e == j.order_mode.order_mode_code) {
                        returnArray.push(j);
                    }
                    // console.log(returnArray,'returnArray');
                });
            });
            // console.log(returnArray);
            return returnArray;
        }
    },
    methods: {
        // 编辑订单模式
        editModeBtn_edit() {
            _this.checkedModes = _this.checkedModes_edit; //指定订单模式编码传递到子组件
            // console.log(_this.checkedModes, '_this.checkedModes');

            _this.editMode_show = !_this.editMode_show;
        },
        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.distance_period1 = ''; //起始公里数
            _this.distance_period2 = ''; //截止公里数
            _this.allModeArr = [];
            _this.checkedModes = [];
            _this.checkedModes_edit = []; // 多选绑定值
            _this.options_mode_code = []; //订单模式编码

            _this.mode_options_data = {
                page: 1,
                limit: 10,
                status: ''
            };
            _this.submit_data = {
                name: '',
                time_start: '',
                time_end: '',
                distance_period: '',
                fee_amount: '',
                fee_rate: '',
                deduct: '',
                order_mode: '',
                status: ''
            };

            _this.distance_period1 = '';
            _this.distance_period2 = '';

            _this.options_mode_code = [];

            _this.checkedModes_edit = [];

            _this.allModeArr = [];
        },
        //获取订单模式
        orderModeList() {
            return new Promise((resolve) => {
                _this.allModeArr = []; // 订单模式数组
                _this.getMode(resolve);
            });
        },
        getMode(resolve) {
            _this
                .$post('/order/orderModeLists', this.mode_options_data)
                .then((res) => {
                    _this.allModeArr = [..._this.allModeArr, ...res.data];

                    if (_this.mode_options_data.page * _this.mode_options_data.limit < res.count) {
                        _this.mode_options_data.page += 1;

                        _this.getMode(resolve);
                    }

                    if (this.allModeArr.length == res.count) {
                        console.log('获取订单模式走完');
                        resolve();
                    }
                })
                .catch((err) => {});
        },

        // 保存数据前整理数据
        toJSON() {
            _this.submit_data.order_mode = JSON.stringify(_this.checkedModes_edit);
            // console.log(_this.checkedModes_edit, '_this.checkedModes_edit');
            // console.log(_this.submit_data.order_mode, '_this.submit_data.order_mode');
            if (_this.distance_period1 == '') {
                _this.$message.error('起始公里数为必填项');
                // console.log(111);
                return;
            } else {
                _this.distance_period_arr = [_this.distance_period1, _this.distance_period2];
                _this.submit_data.distance_period = JSON.stringify(_this.distance_period_arr);
                _this.onSubmitDig();
            }
        },
        // 提交
        onSubmitDig() {
            _this
                .$post('/returnfee/editReturnfeeSubmit', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success('操作成功！');
                    _this.$emit('onSubmit');
                    _this.closeDialog();
                })
                .catch((err) => {});
        },
        getReturnfeeDetails() {
            return new Promise((resolve) => {
                _this
                    .$post('/returnfee/getReturnfeeDetails', {
                        return_trip_conf_code: _this.submit_data.return_trip_conf_code
                    })
                    .then((res) => {
                        // 使用中或者空闲中
                        _this.submit_data.name = res.data.name;
                        _this.submit_data.time_start = res.data.time_start;
                        _this.submit_data.time_end = res.data.time_end;
                        _this.submit_data.distance_period = JSON.parse(res.data.distance_period);
                        _this.checkedModes_edit = JSON.parse(res.data.order_mode);
                        // console.log(_this.allModeArr, '_this.checkedModes_edit勾选的订单模式数量');

                        let allArray = [];

                        for (let index = 0; index < _this.allModeArr.length; index++) {
                            allArray.push(_this.allModeArr[index].order_mode.order_mode_code);
                        }

                        for (let index = 0; index < _this.checkedModes_edit.length; index++) {
                            if (allArray.indexOf(_this.checkedModes_edit[index]) == -1) {
                                // 存在bug，接口返回45个订单模式编码，但是只显示出43个订单模式，所以需要把当时选择的也就是接口返回的订单模式，和订单模式列表接口对比，把后来被删除的订单模式删除
                                // console.log(_this.checkedModes_edit[index], '不存在');
                                _this.checkedModes_edit.splice(index, 1);
                            }
                        }

                        // console.log(_this.checkedModes_edit, '_this.checkedModes_edit');
                        _this.distance_period1 = _this.submit_data.distance_period[0];
                        _this.distance_period2 = _this.submit_data.distance_period[1];

                        _this.submit_data.fee_amount = res.data.fee_amount;
                        _this.submit_data.fee_rate = res.data.fee_rate;
                        _this.submit_data.deduct = res.data.deduct;
                        _this.submit_data.order_mode = res.data.order_mode;
                        _this.submit_data.status = res.data.status.val;

                        resolve();
                        console.log('详情接口赋值走完');
                    })
                    .catch((err) => {});
            });
        }
    }
};
</script>

<style scoped>
.modeStyle {
    margin-bottom: 0px;
    margin-top: 10px;
}

.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
<style>
.modeStyle-contain .el-checkbox {
    width: 200px;
}
</style>
